// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__3CakE"};